import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import React from "react";
import Switch from "@mui/material/Switch";
import styled from "styled-components";
import {
  isSingleSleeperSelector,
  setPrimarySleeperUnitSystem,
  setSecondarySleeperUnitSystem,
  setUnitSystem,
} from "../../redux/slices/mattressConfiguration";

const StyledSwitchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2rem;
`;

const StyledText = styled.div`
  color: white;
  font-weight: bold;
  font-family: noto-sans;
  font-size: 2rem;
`;

const EvrbedSwitch = ({
  checked,
  onChange,
  labelLeft = "",
  labelRight = "",
  textStyles = {},
  switchStyles = {},
  containerStyles = {},
  value,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <StyledSwitchContainer style={{ ...containerStyles }} className="row evrbed-switch">
      <StyledText style={{ ...textStyles }} className="col-auto">
        {labelLeft}
      </StyledText>
      <Switch
        sx={{ color: "red", ...switchStyles }}
        checked={value}
        size="medium"
        color="default"
        onChange={onChange}
      />
      <StyledText style={{ ...textStyles }} className="col-auto">
        {labelRight}
      </StyledText>
    </StyledSwitchContainer>
  );
};

export default EvrbedSwitch;
